export default "__VITE_ASSET__DEnKj_8s__"